export default "__VITE_ASSET__9d2896e9__"